import React from 'react';

interface DayStats {
  label: string;       // e.g. "Mon"
  date: string;        // YYYY-MM-DD
  total: number;
  completed: number;
}

interface WeeklyChartProps {
  stats: DayStats[];
}

export default function WeeklyChart({ stats }: WeeklyChartProps) {
  const today = new Date().toISOString().slice(0, 10);
  const max = Math.max(...stats.map(s => s.total), 1);

  return (
    <div className="weekly-chart">
      {stats.map((day) => {
        const pct = day.total === 0 ? 0 : Math.round((day.completed / day.total) * 100);
        const barHeight = day.total === 0 ? 4 : Math.max(8, Math.round((day.total / max) * 100));
        const isToday = day.date === today;

        return (
          <div key={day.date} className={`week-day ${isToday ? 'week-day-today' : ''}`}>
            <div className="week-bar-wrap" style={{ height: 80 }}>
              <div className="week-bar-track">
                <div
                  className={`week-bar-fill ${pct === 100 ? 'bar-complete' : pct > 0 ? 'bar-partial' : 'bar-empty'}`}
                  style={{ height: `${barHeight}%` }}
                  title={`${day.completed}/${day.total} tasks`}
                />
              </div>
            </div>
            <div className="week-pct">{day.total > 0 ? `${pct}%` : '—'}</div>
            <div className="week-label">{day.label}</div>
            {isToday && <div className="week-today-dot" />}
          </div>
        );
      })}
    </div>
  );
}
